import React, { ReactNode } from 'react';

import { ThemeProvider, useTheme } from '../contexts/Theme.context';
import { IpLookupProvider } from '../contexts/IpLookup.context';

interface Props {
  children: ReactNode;
}

const ThemeApplier = ({ children }: Props) => {
  const { theme } = useTheme();

  return (
    <div className="app-wrapper" style={{ ...(theme as React.CSSProperties) }}>
      {children}
    </div>
  );
};

const AppWrapper = ({ children }: Props) => {
  return (
    <IpLookupProvider>
      <ThemeProvider>
        <ThemeApplier>{children}</ThemeApplier>
      </ThemeProvider>
    </IpLookupProvider>
  );
};

export default AppWrapper;
